export default __webpack_public_path__ + "static/media/Animals09.cbbfbf9d.jpg";